export const SET_LOCAL_FILTER = "SET_LOCAL_FILTER";
